/**
 * Author(s) : Shakthi Priya
 * Purpose : Carousel for banner images in home page. Handled responsiveness.
 */
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import 'swiper/scss';
import styles from './Carousel.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Autoplay } from 'swiper';
import {Logo} from '../../components';
import bannerLogo from '../../assets/images/bannerLogo.png';
import data from '../../assets/data/allspark.json';

function Carousel() {
  const bannerImages = data.bannerImages;
  SwiperCore.use([Autoplay]);

  return (
    <div className={styles.carousel}>
      <Swiper
        modules={[Navigation]}
        navigation
        speed={1000}
        slidesPerView={1}
        pagination={{
          clickable: true,
        }}
        autoplay={{ delay: 1500, disableOnInteraction: false }}
        loop
        className={styles.swiper}>
        <div className={styles.logo}>
          <Logo image={bannerLogo} />
        </div>
        {bannerImages.map((name, index) => {
          const img = require(`../../assets/images/banner/${name}`);
          return (
            <SwiperSlide key={index}>
              <div className={styles.slide}>
                <img src={img} alt={name}></img>
                <div className={styles.gradient}></div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}

export default Carousel;
